import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, useTheme } from '@mui/material'

const ServiceMaterialTypeChip = ({ materialColor, label = '', ...rest }) => {
  const theme = useTheme()
  const textColor = materialColor ? theme.palette.getContrastText(materialColor) : ''

  return (
    <Box
      px={1}
      py={0.5}
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius={1}
      {...(materialColor && { bgcolor: materialColor, color: textColor })}
      {...rest}
    >
      <Typography variant="body1" component="span" fontWeight={400} lineHeight="inherit">
        {label}
      </Typography>
    </Box>
  )
}

ServiceMaterialTypeChip.propTypes = {
  materialColor: PropTypes.string,
  label: PropTypes.string,
}

export default ServiceMaterialTypeChip
